// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"271":"bonos-regalo","669":"ok","757":"ko","779":"error"}[chunkId] || chunkId) + "." + {"271":"2aafc3a1","506":"9b5f290d","669":"49b6d9ba","757":"fcd8b66a","779":"d24abef7","874":"87b89dbf"}[chunkId] + ".js";
};